<template>
  <div class="name">
    <input
      type="text"
      class="primary"
      :class="{ invalid: !valid }"
      onfocus="this.placeholder=''"
      onblur="this.placeholder='TYPE A NAME'"
      v-model="name"
      @input="validate()"
      v-focus
    >

    <button
      class="button primary"
      @click="randomName()"
      v-if="name === null || name === ''"
    >RANDOM NAME</button>

    <div v-if="name && errors.length == 0">
      <p v-if="message">{{ message }}</p>
      <p v-if="submessage">{{ submessage }}</p>
    </div>

    <div class="errors">
      <p
        v-for="error in errors"
        :key="error"
      >{{ error }}</p>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from "vuex";
  import Filter from "di-badwords";
  import { generateName } from "@/lib/name-generator";

  const filter = new Filter();
  const charLimit = 16;

  export default {
    data() {
      return {
        name: "",
        badwords: false,
        message: null,
        submessage: null
      };
    },
    filters: {
      sanatize(name) {
        return filter.clean(name);
      }
    },
    methods: {
      ...mapActions([
        "softUpdatePathfinder",
        "updateErrors",
        "getPathfinderByName",
        "getWordLists"
      ]),
      async randomName() {
        this.name = generateName(charLimit);
        await this.validate();

        while (!this.valid) {
          this.name = generateName(charLimit);
          await this.validate();
        }
      },
      hasBadWords(name) {
        return filter.isProfane(name);
      },
      validate() {
        return new Promise(resolve => {
          this.getPathfinderByName({ params: { name: this.name } }).then(
            response => {
              let sameNamePathfinders = response.data;
              let errors = [];
              this.message = null;
              this.submessage = null;
              this.name = this.name.trim();

              // Remove pathfinder's with same id
              sameNamePathfinders = sameNamePathfinders.filter(
                p => p.id !== this.pathfinder.id
              );

              if (sameNamePathfinders.length > 0) {
                errors.push(
                  "Name must be unique, there is another pathfinder with that name"
                );
              }

              if (this.name.includes("*")) {
                this.name = "";
              }

              if (this.name.length > charLimit) {
                errors.push(`Name must be ${charLimit} characters or less`);
              }

              if (this.hasBadWords(this.name)) {
                this.name = filter.clean(this.name);
                errors.push("This name isn't family friendly, try another name");
              }

              this.updateErrors(errors);

              if (errors.length == 0) {
                this.message = "Congratulations!";
                this.submessage = "This name is available";
                this.softUpdatePathfinder({ name: this.name });
              }

              resolve();
            }
          );
        });
      }
    },
    computed: {
      ...mapState({
        pathfinder: state => state.pathfinders.pathfinder,
        errors: state => state.errors,
        lists: state => state.badwords.lists
      }),
      valid() {
        return this.errors.length == 0;
      },
      defaultList() {
        return this.lists.find(list => list.name === "default");
      }
    },
    activated() {
      this.name = this.pathfinder.name;
    },
    created() {
      this.getWordLists().then(() => {
        if (this.defaultList != undefined) {
          filter.addWords(...this.defaultList.words.map(w => w.text));
        }
      });
    }
  };
</script>

<style lang="scss">
  @import "@/assets/global.scss";

  .name {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .name input {
    width: 75%;
  }

  .name input.invalid {
    color: $primary;
    font-style: italic;
  }

  .name button {
    width: 65%;
    margin: auto;
    margin-bottom: 1em;
  }
</style>
